export default __webpack_public_path__ + "5e2a8e23702151bee0129533dbe91d7d.svg";